import { render, staticRenderFns } from "./PkgRiskSubItemForm.vue?vue&type=template&id=53c8f52a&"
import script from "./PkgRiskSubItemForm.vue?vue&type=script&lang=js&"
export * from "./PkgRiskSubItemForm.vue?vue&type=script&lang=js&"
import style0 from "./PkgRiskSubItemForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgRiskSubItemForm.vue"
export default component.exports